export default __webpack_public_path__ + "static/media/config-icon.43836fa0.svg";